export const subtitles = {
    "1": {
        "startTime": 3.0,
        "endTime": 4.0,
        "transcript": "Ayagtuq?",
        "translation": "Is it going?"
    },
    "2": {
        "startTime": 8.9,
        "endTime": 12.5,
        "transcript": "Kitak' ciumek Kass'acetun atren Yugcetun-llu atren apertuqerru.",
        "translation": "Now, please say your name in English and in Yup'ik."
    },
    "3": {
        "startTime": 13.0,
        "endTime": 17.0,
        "transcript": "My name is Martha Sarah, Yugcetun-llu Uliggaugua.",
        "translation": "My name is Martha Sarah, and I'm Uliggaq in Yup'ik."
    },
    "4": {
        "startTime": 17.1,
        "endTime": 19.5,
        "transcript": "Allrakungqercit qavcinek?",
        "translation": "How old are you?"
    },
    "5": {
        "startTime": 20.0,
        "endTime": 21.0,
        "transcript": "Seventy-nine.",
        "translation": "Seventy-nine."
    },
    "6": {
        "startTime": 23.0,
        "endTime": 27.0,
        "transcript": "Irniaten, tutgaraten, iluperangqerquvet-llu qanrutkeqerki.",
        "translation": "Please talk about your children, grandchildren, and if you have any great-grandchildren."
    },
    "7": {
        "startTime": 28.0,
        "endTime": 35.0,
        "transcript": "Irniangqertua cetamanek, tutgarlua-llu 17, 11 great-grandchildren.",
        "translation": "I have four children, and 17 grandchildren, [and] 11 great-grandchildren."
    },
    "8": {
        "startTime": 35.5,
        "endTime": 40.0,
        "transcript": "Ciumek kitak' qaillun, waten maa-i February-q nangyartulria",
        "translation": "First of all, February is nearing its end now"
    },
    "9": {
        "startTime": 40.5,
        "endTime": 43.9,
        "transcript": "Qaillun tamaani uptelallruat up'nerkiyallerkameggnun?",
        "translation": "How did they prepare to go to their spring camps back then?"
    },
    "10": {
        "startTime": 44.0,
        "endTime": 48.0,
        "transcript": "Up'nerkiyaqata'arqameng-wa April-aami uptenglallrulriit.",
        "translation": "When they were going to go to spring camps, they would start preparing in April."
    },
    "11": {
        "startTime": 48.5,
        "endTime": 53.0,
        "transcript": "Qaniilarluteng-llu canek neqkameggnek up'nerkarpak.",
        "translation": "They also prepared their food supplies for the spring ahead of time."
    },
    "12": {
        "startTime": 54.5,
        "endTime": 57.0,
        "transcript": "Pelatekateng-llu civcarturluki.",
        "translation": "And they went to go set their tents."
    },
    "13": {
        "startTime": 57.5,
        "endTime": 61.0,
        "transcript": "And… atam-llu qitevcugniartua.",
        "translation": "And… I'll slip into English, you see."
    },
    "14": {
        "startTime": 62.0,
        "endTime": 68.0,
        "transcript": "Pinek-llu, angyateng-llu call' ayaulluki aguuteteng-llu.",
        "translation": "And, you know, they would bring their boats and canoes."
    },
    "15": {
        "startTime": 69.5,
        "endTime": 73.0,
        "transcript": "Cat tua-i aturyugarkateng up'nerkillerni ayaulluki.",
        "translation": "They would bring what they would need to their spring camps."
    },
    "16": {
        "startTime": 74.0,
        "endTime": 82.0,
        "transcript": "Nutaan-llu April-aaq man'a qukallra kituan nutaan wangkuta upagluta.",
        "translation": "And then after the middle of April, we would move."
    },
    "17": {
        "startTime": 83.0,
        "endTime": 85.0,
        "transcript": "Tua-i tekilluta nunakamteńun.",
        "translation": "We would arrive to our settlements."
    },
    "18": {
        "startTime": 86.0,
        "endTime": 89.0,
        "transcript": "Cakneq tua-i assirluni nunaniqluni.",
        "translation": "It was very nice and wonderful."
    },
    "19": {
        "startTime": 94.0,
        "endTime": 98.5,
        "transcript": "Niitelallruan-qaa cuqtaqata ulerpagarkaucianek?",
        "translation": "Have you heard about how they gauged whether it would flood?"
    },
    "20": {
        "startTime": 99.5,
        "endTime": 104.5,
        "transcript": "Qanikcaq tangerrluku yullret imkut pitullruut qanikci'rqan.",
        "translation": "The people back then would look at the snow when there was a lot."
    },
    "21": {
        "startTime": 104.6,
        "endTime": 108.8,
        "transcript": "Cali-llu ciku, tua-i-w' cikuli'rqan.",
        "translation": "And the ice when there was a lot."
    },
    "22": {
        "startTime": 109.0,
        "endTime": 115.8,
        "transcript": "Cikurrlugluni qanikcaam akulii cikuluku piaqan",
        "translation": "When it was a little frozen between the snow"
    },
    "23": {
        "startTime": 116.5,
        "endTime": 118.8,
        "transcript": "Nenglaiteqtaarluni-w' tua-i.",
        "translation": "There were repeated warm periods."
    },
    "24": {
        "startTime": 119.0,
        "endTime": 125.0,
        "transcript": "Tamana-gguq tua-i qanikci'rqan, qau͡gna-llu kiatvut qanikci'rqan mel'ituuq.",
        "translation": "They said that when there was lot of snow, and a lot of snow upriver from us, there is a lot of water."
    },
    "25": {
        "startTime": 125.3,
        "endTime": 126.9,
        "transcript": "Mel'irnilallruat.",
        "translation": "They would say that there was a lot of water."
    },
    "26": {
        "startTime": 128.5,
        "endTime": 134.0,
        "transcript": "Qanikcinqurraa-qaa elpet tangvallruan qanikcinkacagallrani?",
        "translation": "Did you see the snowiest time?"
    },
    "27": {
        "startTime": 134.5,
        "endTime": 138.5,
        "transcript": "Qanikcitullruuq imumi mikluta maani; qanikcipiatullruuq.",
        "translation": "There was a lot of snow back when we were small; there used to be so much snow."
    },
    "28": {
        "startTime": 139.0,
        "endTime": 142.5,
        "transcript": "Enet-llu kankut mission houses kiimeng qertullrulriit.",
        "translation": "And those mission houses down there were the only ones most elevated."
    },
    "29": {
        "startTime": 143.8,
        "endTime": 148.0,
        "transcript": "Roof-ait tekilluki piaqluni atrarluni.",
        "translation": "[The snow] would reach their roofs [sloping] down."
    },
    "30": {
        "startTime": 148.5,
        "endTime": 151.0,
        "transcript": "Mayurluta pagaavet ellu'urtaaraqluta.",
        "translation": "We would go up there and slide."
    },
    "31": {
        "startTime": 152.0,
        "endTime": 156.0,
        "transcript": "Elaturrat-llu amiiget qanikciurluki waten piaqluki igteńguluteng.",
        "translation": "And when the entrance porches were shoveled, it would be like an animal den to the doors."
    },
    "32": {
        "startTime": 157.5,
        "endTime": 160.9,
        "transcript": "Tamatum, tuaten-qaa piaqan ulnayukluki aaryualallruut?",
        "translation": "Were they wary of floods when that happened?"
    },
    "33": {
        "startTime": 161.0,
        "endTime": 163.0,
        "transcript": "Yaa, ulerpagnayukluki pilallruut.",
        "translation": "Yes, they would be worried that it would flood."
    },
    "34": {
        "startTime": 163.1,
        "endTime": 174.5,
        "transcript": "Tau͡gaam iliini cukaunani melt-arturaraqan merkaa-gguq ayalartuq.",
        "translation": "But sometimes when it melted slowly, they said that the water went away."
    },
    "35": {
        "startTime": 174.8,
        "endTime": 180.5,
        "transcript": "Evaporate-arluni-w' tua-i pilallilria cali-ll' drain-arturluni.",
        "translation": "It probably evaporated and drained."
    },
    "36": {
        "startTime": 181.0,
        "endTime": 185.0,
        "transcript": "Merpassiyaaksaitaqluni cukaunani piurarqami.",
        "translation": "There wouldn't be a lot of water when it [melted] slowly."
    },
    "37": {
        "startTime": 186.7,
        "endTime": 190.0,
        "transcript": "Qaill'-mi arnat uptelallruat up'nerkiyallerkameggnun?",
        "translation": "Then how did women prepare to go to spring camp?"
    },
    "38": {
        "startTime": 190.1,
        "endTime": 196.0,
        "transcript": "Arnat imumi uptelallruut ivrucililuteng, nat'rarluki ivruciit",
        "translation": "Women back then prepared by making waterproof skin boots, putting soles on waterproof boots"
    },
    "39": {
        "startTime": 197.0,
        "endTime": 199.8,
        "transcript": "Shoe pack-anek-llu aturturayuitellruameng.",
        "translation": "Also because they didn't use shoe packs."
    },
    "40": {
        "startTime": 200.5,
        "endTime": 202.5,
        "transcript": "Ivrucililuteng canek tua-i.",
        "translation": "They made waterproof boots out of various things."
    },
    "41": {
        "startTime": 202.6,
        "endTime": 207.3,
        "transcript": "Imangyuilngurnek pililuteng upakata'arqameng angutet.",
        "translation": "They made waterproof footwear for the men when they were going to move."
    },
    "42": {
        "startTime": 207.4,
        "endTime": 210.5,
        "transcript": "Arnaunge'rmeng-llu tua-i ivrucinek aturluteng piaqluteng.",
        "translation": "And even the women wore waterproof skin boots."
    },
    "43": {
        "startTime": 211.5,
        "endTime": 216.7,
        "transcript": "Cat tua-i upluki aturyulteng mingquatullruameng imkut arnat.",
        "translation": "It was because the women back then used to sew to prepare what they would need."
    },
    "44": {
        "startTime": 217.0,
        "endTime": 221.0,
        "transcript": "Wangkucicetun ayuqellrunritut; qessanqurrullrunritut.",
        "translation": "They weren't like us; they weren't lazy."
    },
    "45": {
        "startTime": 223.0,
        "endTime": 228.0,
        "transcript": "Maa-i-qaa, maa-i-qaa qanilallran ayuqenritaa imumi?",
        "translation": "Is the snow not like how it was back then?"
    },
    "46": {
        "startTime": 228.1,
        "endTime": 230.0,
        "transcript": "Tuar tang maa-i imucetun",
        "translation": "It seems that now, [un]like back then"
    },
    "47": {
        "startTime": 230.5,
        "endTime": 237.0,
        "transcript": "Wiinga-w' tua-i imumi elitnaungeqarraallemni-ll' qanikcitullruuq.",
        "translation": "Well, when I first started school back then, there used to be a lot of snow."
    },
    "48": {
        "startTime": 237.5,
        "endTime": 242.0,
        "transcript": "Cakneq tua-i big snow banks; cakneq tua-i nunaniqluni.",
        "translation": "Very big snow banks; it was quite wonderful."
    },
    "49": {
        "startTime": 242.2,
        "endTime": 250.5,
        "transcript": "Elagluta-llu igciaqluta, enelinguaraqluta-ll' qengaruut iluitni angluteng.",
        "translation": "We also dug tunnels, and made houses in big snow hills."
    },
    "50": {
        "startTime": 251.0,
        "endTime": 254.5,
        "transcript": "Maa-i tang tua-i tuaten piyuirutellria.",
        "translation": "Now, you see, that doesn't happen anymore."
    },
    "51": {
        "startTime": 256.0,
        "endTime": 260.5,
        "transcript": "Maa-i-llam tua-i qanikcalirngacaaquq, tuaten tau͡gaam pitavkenani.",
        "translation": "It seems like there's a lot of snow now, but it's not like that."
    },
    "52": {
        "startTime": 260.8,
        "endTime": 264.4,
        "transcript": "Roof-at-llu tekilluki qanikcangqeksaunani.",
        "translation": "The snow hasn't reached the roofs either."
    },
    "53": {
        "startTime": 266.5,
        "endTime": 271.5,
        "transcript": "Nateqvanun… tua-i-llu-q' up'nerkiyarraarluteng egmian kiagvimeggnun ayagluteng?",
        "translation": "How far… and then after spring camp, would they go to their summer camps right away?"
    },
    "54": {
        "startTime": 271.8,
        "endTime": 280.5,
        "transcript": "June-ami utertetullruut tangerrluki green-angaqata cat makut naunraat.",
        "translation": "They would go back depending on how green the plants became in June."
    },
    "55": {
        "startTime": 280.6,
        "endTime": 283.8,
        "transcript": "Green-angaqata June-ami utertetullruut.",
        "translation": "They would go home when they became green in June."
    },
    "56": {
        "startTime": 284.0,
        "endTime": 288.9,
        "transcript": "Iliini-llu capuraugaqluteng ciku urugnaciarluku",
        "translation": "And sometimes, they would be weatherbound by the late melting of the ice"
    },
    "57": {
        "startTime": 289.0,
        "endTime": 296.0,
        "transcript": "Nanvat kuiguat-llu qerarciigataqluki ayagciigatqaqluteng.",
        "translation": "Unable to travel by crossing rivers and oxbow lakes."
    },
    "58": {
        "startTime": 297.5,
        "endTime": 299.9,
        "transcript": "Tau͡gaam tua-i urugaqan utertetullruut",
        "translation": "They only returned when it melted"
    },
    "59": {
        "startTime": 300.0,
        "endTime": 303.8,
        "transcript": "Tevluteng-llu piaqluteng Kusquqvagmun.",
        "translation": "And they would portage to the Kuskokwim."
    },
    "60": {
        "startTime": 304.4,
        "endTime": 309.0,
        "transcript": "Kusquqvak cali cup'aqami nallunaitaqluni Akumelnge'rmi.",
        "translation": "And when the ice broke up on the Kuskokwim, it was noticable even in the Akula region."
    },
    "61": {
        "startTime": 309.5,
        "endTime": 311.9,
        "transcript": "Niitnarqaqluni pillra.",
        "translation": "It was audible when it happened."
    },
    "62": {
        "startTime": 312.0,
        "endTime": 318.0,
        "transcript": "Canek wani waten allrakuq ellirluku caqtaalallruat yuraq ilakluku?",
        "translation": "At this time of year, what did they do, including Yup'ik dance festivals?"
    },
    "63": {
        "startTime": 319.0,
        "endTime": 322.0,
        "transcript": "Calarnillrukait? Avgarutaarnilallruit.",
        "translation": "What did they call it? They said that they used to have the Sharing Festival [Avgarutaaryaraq]."
    },
    "64": {
        "startTime": 323.0,
        "endTime": 327.0,
        "transcript": "Kelegluteng yurallmeng kinguani nunat",
        "translation": "After they held Yup'ik dance festivals, villages would invite others"
    },
    "65": {
        "startTime": 328.0,
        "endTime": 332.0,
        "transcript": "Mamterillermiut ukut uaqliit inglukluki, kiaqliit inglukluki.",
        "translation": "Villages downriver and upriver from Bethel would compete."
    },
    "66": {
        "startTime": 332.5,
        "endTime": 335.0,
        "transcript": "Wagg'uq Avgarutaarluteng.",
        "translation": "They called that Avgarutaarluteng."
    },
    "67": {
        "startTime": 335.0,
        "endTime": 339.0,
        "transcript": "Makumiungurrlainang'e'rmeng, ii-i.",
        "translation": "Even if it was just the people from here, yes."
    },
    "68": {
        "startTime": 340.0,
        "endTime": 347.0,
        "transcript": "Inglukluteng piaqluteng ingkut iquteng kelegluki canek tua-i piluteng.",
        "translation": "They would compete against each other, inviting the village at the end and [giving] them things."
    },
    "69": {
        "startTime": 348.0,
        "endTime": 356.0,
        "transcript": "Canek-wa tua-i qasgimun ayaulluteng, traps and all kinds of things.",
        "translation": "They would bring various things to the community house, traps and all kinds of things."
    },
    "70": {
        "startTime": 358.0,
        "endTime": 359.0,
        "transcript": "Camek-qaa ilakangqertuq?",
        "translation": "Is there anything else to add?"
    },
    "71": {
        "startTime": 359.5,
        "endTime": 362.5,
        "transcript": "Tua-i-w' tuaten tau͡gaam pitullrulriit wii takumni.",
        "translation": "That's all they did in my presence."
    },
    "72": {
        "startTime": 365.0,
        "endTime": 368.0,
        "transcript": "Upangaqata tua-i taq'aqluteng.",
        "translation": "They would stop when they started moving."
    },
    "73": {
        "startTime": 370.0,
        "endTime": 374.5,
        "transcript": "Tuaten-am tua-i anglanarqellruut anagtassiigulluteng.",
        "translation": "It was fun watching them compete."
    },
    "74": {
        "startTime": 375.0,
        "endTime": 379.8,
        "transcript": "Tua-i kingumek taqellriit win-araqluteng.",
        "translation": "The last ones to finish would win."
    },
    "75": {
        "startTime": 379.9,
        "endTime": 382.8,
        "transcript": "Cakucinek anagtassiiraqluteng? Qaillun?",
        "translation": "What kinds of contests did they have? How [did they go]?"
    },
    "76": {
        "startTime": 383.0,
        "endTime": 389.7,
        "transcript": "Tua-i-w' tuaten kingumek wani kelellret, canek-llu tua-i agulluteng qasgimun.",
        "translation": "The last one to invite like that, and they would bring things to the community house."
    },
    "77": {
        "startTime": 390.0,
        "endTime": 393.5,
        "transcript": "Tua-i-ll' ingluita ingkut akivkenaki taqluteng.",
        "translation": "And then their competitors over there would stop without reciprocating."
    },
    "78": {
        "startTime": 394.0,
        "endTime": 395.9,
        "transcript": "Tua-i taukut win-arluteng.",
        "translation": "That [inviting] village would win."
    },
    "79": {
        "startTime": 396.8,
        "endTime": 397.9,
        "transcript": "Nunuliutengaqluteng?",
        "translation": "Did they have prizes?"
    },
    "80": {
        "startTime": 398.0,
        "endTime": 403.0,
        "transcript": "Nuu. Nuu, they just… (Kiingan aquiluteng.)",
        "translation": "No. No, they just… (They just had fun.)"
    },
    "81": {
        "startTime": 404.5,
        "endTime": 407.0,
        "transcript": "Anglanarqelallruut-am.",
        "translation": "They were fun."
    },
    "82": {
        "startTime": 407.0,
        "endTime": 409.0,
        "transcript": "Tua-i-w' amlleriuq. (Ii-i.)",
        "translation": "Well, that's enough. (Yes.)"
    },
    "83": {
        "startTime": 413.0,
        "endTime": 418.5,
        "transcript": "Kitak' ava-i-cetun Martha-cetun Kass'acetun Yugcetun-ll' atren apertuqerru.",
        "translation": "Okay, like Martha just now, please say your name in English and Yup'ik."
    },
    "84": {
        "startTime": 418.6,
        "endTime": 423.5,
        "transcript": "Okay, Yugtun-wa Kumangulriamek pitullrukiitnga, Matthew-mek-ll' Kass'atun.",
        "translation": "Okay, they called me Kumangulria in Yup'ik, and Matthew in English."
    },
    "85": {
        "startTime": 424.0,
        "endTime": 426.5,
        "transcript": "Irniaten, tutgaraten, tamakut qanrutkeqerki.",
        "translation": "Please talk about your children [and] grandchildren."
    },
    "86": {
        "startTime": 426.6,
        "endTime": 430.0,
        "transcript": "Wiinga qulngunrita'arnek irniangqertua nakmiin",
        "translation": "I have nine children of my own"
    },
    "87": {
        "startTime": 430.1,
        "endTime": 434.5,
        "transcript": "Arvinleggarnek-llu tutgarangqerrlua, iluperaunii-llu.",
        "translation": "And only six grandchildren, and no great-grandchildren."
    },
    "88": {
        "startTime": 435.0,
        "endTime": 437.0,
        "transcript": "Nani anglillrusit? (Wait, wait.)",
        "translation": "Where did you grow up? (Wait, wait.)"
    },
    "89": {
        "startTime": 438.0,
        "endTime": 439.0,
        "transcript": "Ready?",
        "translation": "Ready?"
    },
    "90": {
        "startTime": 439.8,
        "endTime": 442.5,
        "transcript": "Nani anglillrusit? Anglillren kitak' qa[nrutkeqerru].",
        "translation": "Where did you grow up? [Please] talk about how you grew up."
    },
    "91": {
        "startTime": 443.0,
        "endTime": 445.6,
        "transcript": "Kuigpagmi [Acacaryutmi] anglillruunga",
        "translation": "I grew up on the Yukon [in Acacaryun]"
    },
    "92": {
        "startTime": 445.7,
        "endTime": 451.5,
        "transcript": "Tau͡gaam Ingrirrallermun elitnaullruunga tamaani miklua.",
        "translation": "But I went to school in Holy Cross back when I was small."
    },
    "93": {
        "startTime": 452.5,
        "endTime": 460.5,
        "transcript": "Ataam cali uterqaarlua 11 years, qula ataucimek allrakunek uitarraarlua, Mt. Edgecumbe-aamun ataam ayanqigglua.",
        "translation": "After I stayed for 11 years, qula ataucimek allrakunek, after going home I went again to Mt. Edgecumbe."
    },
    "94": {
        "startTime": 460.6,
        "endTime": 465.0,
        "transcript": "Ayagngama qulni allrakuni tamaanqaarlua elitnaurlua",
        "translation": "After I was there for ten years going to school"
    },
    "95": {
        "startTime": 465.8,
        "endTime": 470.0,
        "transcript": "Tamaani-ll' calingerraarlua maavet Mamterillermun tailua.",
        "translation": "And after getting a job there, I came here to Bethel."
    },
    "96": {
        "startTime": 470.1,
        "endTime": 473.8,
        "transcript": "Nugtarrlua-wa yungcarvigmi piani calilua.",
        "translation": "I moved and worked inland at the hospital."
    },
    "97": {
        "startTime": 474.0,
        "endTime": 477.0,
        "transcript": "Calillruunga 17 years.",
        "translation": "I worked for 17 years."
    },
    "98": {
        "startTime": 479.5,
        "endTime": 485.0,
        "transcript": "Yungcarvigmek calilqa mernuyagulluku BIA-nun nugtartellemni",
        "translation": "When I got tired of working at the hospital and moved to the BIA [school]"
    },
    "99": {
        "startTime": 485.1,
        "endTime": 489.5,
        "transcript": "Arvinlegni allrakuni calirraarlua calisciigaliniatnga",
        "translation": "When they told me I couldn't work anymore after working for six years"
    },
    "100": {
        "startTime": 490.0,
        "endTime": 496.0,
        "transcript": "Yungcaristet calinanrircetellruatnga qukamnek naulluutengama.",
        "translation": "The doctors had me quit working because I got an ailment in my midsection."
    },
    "101": {
        "startTime": 496.8,
        "endTime": 499.8,
        "transcript": "Anglillerpeni Kuigpagmi canek tangaalallrusit?",
        "translation": "What did you see when you grew up on the Yukon?"
    },
    "102": {
        "startTime": 499.9,
        "endTime": 502.5,
        "transcript": "Like, qaillukualallruat waten elli'irqan?",
        "translation": "Like, what did they do when [the season] became like this?"
    },
    "103": {
        "startTime": 503.3,
        "endTime": 513.0,
        "transcript": "Up'nerkami wani maa-i-rpak cat neqet Kuigpagmi can'giiret-ll' makut enurnariqertelartut.",
        "translation": "In the spring on the Yukon these days, various fish including these blackfish become scarce."
    },
    "104": {
        "startTime": 513.8,
        "endTime": 520.0,
        "transcript": "Taumek man'a maani Kanruyaucimek pilallerci qagaani Kuigpagmi Unguurvigmek pilaraat.",
        "translation": "That's why what you call Kanruyauciq [February] here is called Unguurvik [Time of Driving Game] up on the Yukon."
    },
    "105": {
        "startTime": 520.7,
        "endTime": 528.0,
        "transcript": "Maqaruanek tau͡gaam unguluteng nerengnaquratullrulliniut tamaani mat'um iralum nalliini.",
        "translation": "In this month back then, they only subsisted by driving hares."
    },
    "106": {
        "startTime": 530.0,
        "endTime": 534.4,
        "transcript": "Qanikcarpallrani-qaa Kuigpagmi murilkellruuten wall' nani?",
        "translation": "Did you observe a lot of snow on the Yukon or somewhere else?"
    },
    "107": {
        "startTime": 534.5,
        "endTime": 539.5,
        "transcript": "Yaa, tamaani 1930s qanikcarpatullruuq tan'gurraulua.",
        "translation": "Yes, there used to be a lot of snow back in the 1930s when I was a boy."
    },
    "108": {
        "startTime": 540.5,
        "endTime": 549.0,
        "transcript": "Iliikun ungaliquluni waten qaniquluni-ll' piaqan maraq cirmiggnilaraat.",
        "translation": "Sometimes when there was a lot of southern winds and snowing, they would say the the marsh cirmiggluni."
    },
    "109": {
        "startTime": 549.1,
        "endTime": 550.5,
        "transcript": "Cikuluni-gguq.",
        "translation": "They said it froze."
    },
    "110": {
        "startTime": 551.0,
        "endTime": 558.5,
        "transcript": "Maa-i qanikcangqeng'e'rmi cirmigcimanrituq man'a nunapik.",
        "translation": "Even though there's a lot of snow now, the tundra here is not frozen."
    },
    "111": {
        "startTime": 560.9,
        "endTime": 565.4,
        "transcript": "Waten qanikcing'e'rmi iliikun merpayuituq mel'ing'e'rmi.",
        "translation": "Sometimes, though there's a lot of snow like this, it doesn't flood even with a lot of water."
    },
    "112": {
        "startTime": 565.5,
        "endTime": 570.0,
        "transcript": "Tau͡gaam cikui[?] [?]naciarlartuq.",
        "translation": "But the ice [?melts in the region] late."
    },
    "113": {
        "startTime": 570.5,
        "endTime": 577.0,
        "transcript": "Tamaa-i-gguq aipaagni qerruvkaqtaarluni merkani nangciqaa.",
        "translation": "They say that it repeatedly freezes and depletes its [flood] water."
    },
    "114": {
        "startTime": 578.5,
        "endTime": 584.0,
        "transcript": "Tau͡gaam imumek cikuugaqami tuatnasciigataqan nutaan merpanglartuq.",
        "translation": "Only when it's frozen and can't do that, there is flooding."
    },
    "115": {
        "startTime": 584.1,
        "endTime": 589.5,
        "transcript": "Cali makut kuiget qanikcarmek amllermek imangqerrluteng cali ciku mamtunrituq.",
        "translation": "Also, when these rivers have a lot of snow, the ice isn't thick."
    },
    "116": {
        "startTime": 590.0,
        "endTime": 599.0,
        "transcript": "Mamtulaucimitun mamtunrilan imartung'e'rmi ulerpagnayukluku wii umyuarteqenritua tamatumek picirluku.",
        "translation": "Because it's not as thick as it usually is even with a lot of water, I don't think it'll flood because of that."
    },
    "117": {
        "startTime": 600.0,
        "endTime": 604.2,
        "transcript": "Tamaani-qaa yuut wani nengelvakayagqan",
        "translation": "Did the people back when it used to be extremely cold"
    },
    "118": {
        "startTime": 604.3,
        "endTime": 606.9,
        "transcript": "Maa-i-cetun ayuqenrilnguq nallunrilken.",
        "translation": "You know that it's not like now."
    },
    "119": {
        "startTime": 607.0,
        "endTime": 609.0,
        "transcript": "Qerrulrianek-qaa niitelallruuten?",
        "translation": "Did you hear about people freezing to death?"
    },
    "120": {
        "startTime": 609.1,
        "endTime": 614.8,
        "transcript": "Qerrulrianek niicuitellruukut maqartulrianek melqulegnek aturangqetullruamta.",
        "translation": "We didn't hear about anyone freezing to death because we had warm fur clothes."
    },
    "121": {
        "startTime": 615.0,
        "endTime": 619.0,
        "transcript": "Maa-i cali nenglling'e'rmi nengllirlallni tekiteksaitaa.",
        "translation": "And even though it's cold now, it doesn't reach the cold it used to."
    },
    "122": {
        "startTime": 620.5,
        "endTime": 624.0,
        "transcript": "Wangkuta tua-i maa-i elluatunek aturangqerrnanriamta",
        "translation": "Because we don't have appropriate clothes anymore now"
    },
    "123": {
        "startTime": 624.1,
        "endTime": 629.0,
        "transcript": "Nengllicuaqerqan nengllirniluku piyugtukut.",
        "translation": "When it's a little chilly we like to say it's cold."
    },
    "124": {
        "startTime": 629.5,
        "endTime": 635.5,
        "transcript": "Niitelallruuten-qaa qaillun cuqtelallritnek ulerpagciqniluku wall'u-q' ulngaitniluku?",
        "translation": "Did you used to hear about how they gauged whether it would flood or not?"
    },
    "125": {
        "startTime": 635.7,
        "endTime": 638.0,
        "transcript": "Tua-i-w' tamatumek qanruskemken ava-i maraq man'a…",
        "translation": "Well, I just told you about the marsh here…"
    },
    "126": {
        "startTime": 639.0,
        "endTime": 641.4,
        "transcript": "Ca tangerrluku nallunrit'lallruat?",
        "translation": "What did they look at to find out?"
    },
    "127": {
        "startTime": 641.5,
        "endTime": 644.0,
        "transcript": "Qau͡gna-qaa tangvagluku wall'u-qaa unegna?",
        "translation": "Did they watch the area upriver or downriver?"
    },
    "128": {
        "startTime": 645.0,
        "endTime": 649.4,
        "transcript": "Waniwa-am waten qanikcing'e'rmi up'nerkami tau͡gaam nallunaituuq.",
        "translation": "Even though there's a lot of snow like this now, it only gets foreseeable in the spring."
    },
    "129": {
        "startTime": 649.5,
        "endTime": 656.0,
        "transcript": "Waten puqlanirraarluni unugmi nenglliqulallra, tamaa-i-gguq qerruvkaqtaarluni.",
        "translation": "When it gets cold at night after being warm like this, they call that repeated freezing."
    },
    "130": {
        "startTime": 656.1,
        "endTime": 658.8,
        "transcript": "Ca tekilluku nengllilallrua?",
        "translation": "Until when would it be cold?"
    },
    "131": {
        "startTime": 658.9,
        "endTime": 662.0,
        "transcript": "Iliikun kiagnaciararqami",
        "translation": "Sometimes when summer was late"
    },
    "132": {
        "startTime": 662.5,
        "endTime": 670.0,
        "transcript": "Kiagnaciallrani man'a Kaugun qulngurteqerluku cikuirutellruuq qagna Kuigpak.",
        "translation": "When summer came late up on the Yukon, the ice melted on the 10th of February."
    },
    "133": {
        "startTime": 671.0,
        "endTime": 681.9,
        "transcript": "Man'a Kayangut Anutiit qukallra kiturluku nutaan kiagyungellruuq tuani nalliini pillrani.",
        "translation": "When that happened, summer started to set past the middle of May."
    },
    "134": {
        "startTime": 682.0,
        "endTime": 685.0,
        "transcript": "I think it was about 1936.",
        "translation": "I think it was about 1936."
    },
    "135": {
        "startTime": 687.0,
        "endTime": 692.0,
        "transcript": "Cali maa-i Paaskaaq kinguqsigtuq. Cali maa-i…",
        "translation": "Now, Easter is also late. And now…"
    },
    "136": {
        "startTime": 692.5,
        "endTime": 696.5,
        "transcript": "Kiagyaraullmi kinguqsinruluku kiagciquq.",
        "translation": "Summer will set later than it usually does."
    },
    "137": {
        "startTime": 697.5,
        "endTime": 702.0,
        "transcript": "Una cali Paaskaaq cuqyuteklaraat maa-i-rpak.",
        "translation": "These days, they also use Easter to gauge the seasons."
    },
    "138": {
        "startTime": 704.8,
        "endTime": 707.4,
        "transcript": "Kinguqsigaqan kinguqsigiciqniluku kiallerkaa.",
        "translation": "When it's later [than Easter], they would say summer will set late."
    },
    "139": {
        "startTime": 707.5,
        "endTime": 713.0,
        "transcript": "Ciuqsian cali Paaskaarmun cali kiagyariurciqniluku.",
        "translation": "When it's before Easter, they also say summer will set early."
    },
    "140": {
        "startTime": 713.5,
        "endTime": 715.4,
        "transcript": "Groundhog-anek-qaa murilkessuunata?",
        "translation": "So we don't observe groundhogs?"
    },
    "141": {
        "startTime": 715.5,
        "endTime": 717.5,
        "transcript": "Tamakunek nalluukut.",
        "translation": "We don't know about those."
    },
    "142": {
        "startTime": 718.5,
        "endTime": 725.5,
        "transcript": "Waten allrakuq elli'irqan qaillun tangvallerpeni anglillerpeni-llu caqtaalallruat? Qaill piaqluteng?",
        "translation": "From what you saw growing up, what would they do this time of year? How would they do them?"
    },
    "143": {
        "startTime": 725.8,
        "endTime": 727.8,
        "transcript": "Cavakalallrunritut tamaani.",
        "translation": "They didn't do too much back then."
    },
    "144": {
        "startTime": 727.9,
        "endTime": 734.0,
        "transcript": "Wiinga yuilqurpallurmi anglillruunga; nunani uitavkenata.",
        "translation": "I grew up mostly in the wilderness; we didn't live in settlements."
    },
    "145": {
        "startTime": 734.5,
        "endTime": 737.0,
        "transcript": "Makunek canek kiingan avungnaqluta.",
        "translation": "We only tried to gather these various things."
    },
    "146": {
        "startTime": 737.5,
        "endTime": 740.5,
        "transcript": "Tamatum-ll' nalliini Kuigpak neqaitellruuq.",
        "translation": "And at that time, there was no fish in the Yukon."
    },
    "147": {
        "startTime": 741.5,
        "endTime": 744.0,
        "transcript": "Cali uum unisteḿa qanrutellruanga tamaani",
        "translation": "My late father also told me back then"
    },
    "148": {
        "startTime": 744.1,
        "endTime": 750.0,
        "transcript": "Ellii-gguq cali tan'gurrauluni neqaismillruuq.",
        "translation": "When he was a boy also, there was [a time of] no fish too."
    },
    "149": {
        "startTime": 750.4,
        "endTime": 757.5,
        "transcript": "Kuigpak tamana neqaitaqami cetamani ukuni allrakuni neqaitetullruuq, neqaitetulliniuq.",
        "translation": "When the Yukon has no fish, it apparently has no fish for four years."
    },
    "150": {
        "startTime": 757.8,
        "endTime": 764.0,
        "transcript": "Alqunarmek neqairtevkenani; allamikuaqan neqai ikegglingiinarluteng.",
        "translation": "The fish wouldn't suddenly disappear; the fish declined every year."
    },
    "151": {
        "startTime": 764.7,
        "endTime": 771.0,
        "transcript": "Tuatnaaqan tamatum nalliini, neqaitellran nalliini ellangellruama",
        "translation": "When that happened at the time, because my earliest memories are when there was no fish"
    },
    "152": {
        "startTime": 771.1,
        "endTime": 775.9,
        "transcript": "Yuilqurpallurmi uitatullruukut, nunani uitayuunata",
        "translation": "We stayed mostly in the wilderness, not in settlements"
    },
    "153": {
        "startTime": 776.0,
        "endTime": 778.5,
        "transcript": "Ukut cali nakmiin anelgutenka.",
        "translation": "Including my blood siblings."
    },
    "154": {
        "startTime": 779.0,
        "endTime": 785.9,
        "transcript": "Ukut ilaput yuratuyaaqut, tau͡gaam ukut wangkuta anelgutkuralriani yurayuitellruukut.",
        "translation": "Our peers Yup'ik dance, but we siblings never Yup'ik danced."
    },
    "155": {
        "startTime": 786.0,
        "endTime": 789.0,
        "transcript": "Aanavut aatavut-ll' yurayuunani.",
        "translation": "Neither did our mother and father Yup'ik dance."
    },
    "156": {
        "startTime": 790.5,
        "endTime": 796.0,
        "transcript": "Tau͡gaam tamatumek nalqigutellrunritaitkut ciin piyuitellemteńek tuaten.",
        "translation": "But they didn't explain why we didn't do that."
    },
    "157": {
        "startTime": 796.1,
        "endTime": 798.8,
        "transcript": "Up'nerkiyallerkamun qaillun uptelallruceci?",
        "translation": "How did youpl prepare to go to spring camps?"
    },
    "158": {
        "startTime": 799.0,
        "endTime": 808.0,
        "transcript": "Tamaani-wa Paaskaam kinguaqaani angyaput upaulluki uptelaqeput, pelatekat tuaten naparrluki.",
        "translation": "Right after Easter back then, we would prepare by moving our boats, even setting up tents."
    },
    "159": {
        "startTime": 809.0,
        "endTime": 813.5,
        "transcript": "Cali taluyat, taluyarkaitnek up'nerkami piluteng.",
        "translation": "And fish traps, they [made] fish traps in the spring."
    },
    "160": {
        "startTime": 814.0,
        "endTime": 815.0,
        "transcript": "Arnat-mi?",
        "translation": "What about the women?"
    },
    "161": {
        "startTime": 815.5,
        "endTime": 822.9,
        "transcript": "Arnat-llu-w' tamaa-i issratnek tuaten caliluteng kineryat, kineryautemeggnek caqukaitnek",
        "translation": "And back then, women would make grass packs to store the meat they dried"
    },
    "162": {
        "startTime": 823.0,
        "endTime": 831.0,
        "transcript": "Can'giirnek, luqruuyagnek tuaten kineryilaameng, makunek-llu yaqulegnek kineryiluteng.",
        "translation": "Because they dried blackfish, even pike, and dried these birds."
    },
    "163": {
        "startTime": 833.5,
        "endTime": 836.0,
        "transcript": "Kiagmi tamakunek kineryanek",
        "translation": "Those dried meats in the summer"
    },
    "164": {
        "startTime": 838.0,
        "endTime": 846.3,
        "transcript": "Fish-anek-wa nererrlainallerkarput pitekluku yaqulegnek kineryilallrulriit freezer-aitelallruamta-llu maa-i.",
        "translation": "Because fish might be our only food, they dried birds also because we didn't have freezers here."
    },
    "165": {
        "startTime": 846.4,
        "endTime": 848.0,
        "transcript": "Qaillun freezer-aalallruat?",
        "translation": "How did they use like freezers?"
    },
    "166": {
        "startTime": 849.0,
        "endTime": 858.5,
        "transcript": "Pi, amaqliqa elagulluku ekviim qacarnerani nunamek pilillruuq.",
        "translation": "You know, my older brother made one out of the land by digging the side of a cliff."
    },
    "167": {
        "startTime": 858.6,
        "endTime": 861.4,
        "transcript": "Uksumi tau͡gken cikumek imiraqluki",
        "translation": "In the winter, however, he would fill them with ice"
    },
    "168": {
        "startTime": 861.5,
        "endTime": 864.8,
        "transcript": "Canegnek ekiarluki kegglallernek tuani.",
        "translation": "Lining them with grass that he sawed there."
    },
    "169": {
        "startTime": 865.0,
        "endTime": 873.0,
        "transcript": "Tuaten cat qemaggnarqellriit up'nerkami tuavet qemaggluki assirupakayuitellruut.",
        "translation": "When the things that needed to be stored in the spring were stored there, they wouldn't spoil too much."
    },
    "170": {
        "startTime": 874.5,
        "endTime": 879.5,
        "transcript": "Tau͡gaam tuaten maanicetun watua kumlivigunateng uitalallruut.",
        "translation": "But, that's how they lived without freezers like we have here now."
    },
    "171": {
        "startTime": 880.0,
        "endTime": 885.0,
        "transcript": "Ulenkacagallrani-qaa quyipiarluku tangellruuten?",
        "translation": "Have you ever seen an extreme flood that was very high?"
    },
    "172": {
        "startTime": 885.1,
        "endTime": 887.0,
        "transcript": "Ataucirqumek tuatnallruuq.",
        "translation": "That happened once."
    },
    "173": {
        "startTime": 887.9,
        "endTime": 893.5,
        "transcript": "Cali makumiungurrlua cali ataucirqumek man'a imartullruuq.",
        "translation": "Also, when I moved here, it was [over]full here once."
    },
    "174": {
        "startTime": 894.3,
        "endTime": 897.2,
        "transcript": "Kan'a kanani ingkut bridge-at qeraryarat",
        "translation": "The bridges, qeraryarat, down and over there"
    },
    "175": {
        "startTime": 897.3,
        "endTime": 902.0,
        "transcript": "Kepenkum qeraryarai ukut pugtercarpiarluki.",
        "translation": "It almost made the bridges on Kepenkuq float."
    },
    "176": {
        "startTime": 902.4,
        "endTime": 914.0,
        "transcript": "Tuaten man'a ulngarteqatallrani qimallruukut Kuigpagmun [Acacaryun] tauna ingrini uitaan.",
        "translation": "When it was going to flood like that here, we escaped to the Yukon because [Acacaryun] there is on the mountains."
    },
    "177": {
        "startTime": 914.1,
        "endTime": 919.5,
        "transcript": "Maaten negetmurtukut maraq man'a mermek imarluni tamarmi",
        "translation": "When we went north, it turned out that all of the marsh here had water"
    },
    "178": {
        "startTime": 921.5,
        "endTime": 925.0,
        "transcript": "Uani Mountain Village-am uatiikun tuvtelliniami.",
        "translation": "Because the [ice] apparently choked downriver from Mountain Village."
    },
    "179": {
        "startTime": 926.5,
        "endTime": 928.8,
        "transcript": "Qemit tau͡gaam kiimeng nunauluteng.",
        "translation": "Hills were the only land [above the water]."
    },
    "180": {
        "startTime": 929.0,
        "endTime": 931.7,
        "transcript": "Tuarpiaq imarpiulria man'a avatvut.",
        "translation": "It seemed like the ocean around us."
    },
    "181": {
        "startTime": 931.8,
        "endTime": 938.9,
        "transcript": "Cali qakemna imarturiqercan tuaten cali ukatmun tailuta man'a entengellrani.",
        "translation": "When it started getting [over]full up north, we came toward here again when the tide was going out."
    },
    "182": {
        "startTime": 939.0,
        "endTime": 941.5,
        "transcript": "Cali man'a imartuqapiggluni.",
        "translation": "It was also extremely [over]full here."
    },
    "183": {
        "startTime": 942.9,
        "endTime": 950.0,
        "transcript": "Ukut qeraryarait road-at-llu qerturikaniirpailgatki qaingiryarpiallruit tuani imartullrani.",
        "translation": "Before they elevated these bridges and roads, it almost [flooded] over them when it was [over]full then."
    },
    "184": {
        "startTime": 950.1,
        "endTime": 954.0,
        "transcript": "Tuaten imartutaluku man'a Kusquqvak tangellruaqa.",
        "translation": "I saw the Kuskokwim get that full."
    },
    "185": {
        "startTime": 954.5,
        "endTime": 960.5,
        "transcript": "Cali 1937-ami piyugnarquq, Kuigpak imartullrani cali",
        "translation": "Also, I think it was in 1937 when the Yukson was [over]full too"
    },
    "186": {
        "startTime": 961.5,
        "endTime": 967.5,
        "transcript": "Tamaaggun-ll' tengssutetgun ayayuitellruamta tamana maraq merrlainaurtellruuq.",
        "translation": "And because we wouldn't travel with planes through there, the marsh there was completely covered with water."
    },
    "187": {
        "startTime": 968.5,
        "endTime": 974.5,
        "transcript": "Kanaqlagcullemteńi-ll' tamaani amaqliqa-ll' malikurlaamegnuk",
        "translation": "And when we went hunting for muskrats, because my older brother and I always went together then"
    },
    "188": {
        "startTime": 975.0,
        "endTime": 986.5,
        "transcript": "Mel'inga'artellrani nalkunek ilapuk ullallruapuk nunapik qainga merrlaingaungan.",
        "translation": "When the water level was increasing, we went to our family whom we found because the land was completely covered with water."
    },
    "189": {
        "startTime": 987.5,
        "endTime": 996.0,
        "transcript": "Tau͡gaam tamakut ciuliaput waten imartungraan nunam qaingiyuitellrani up'nerkitullrulliniut.",
        "translation": "But our ancestors would apparently have spring camps in places the land wouldn't be covered [with water] even when it was [over]full."
    },
    "190": {
        "startTime": 996.8,
        "endTime": 1001.5,
        "transcript": "Tua-i ak'a avani yaaqvanek ayagluku tamana nallunrilamegteggu",
        "translation": "Because they had known that since time immemorial"
    },
    "191": {
        "startTime": 1002.0,
        "endTime": 1006.0,
        "transcript": "Qaingiqtaalriamun waten kinguitni pissuinanratni",
        "translation": "As they hunted in the aftermath of [the land] being covered"
    },
    "192": {
        "startTime": 1006.5,
        "endTime": 1013.5,
        "transcript": "Mer'em tekitellerkaanek nanikuallerkaanek picilirluki tuaten nunalilallrulliniut.",
        "translation": "They established settlements like that because they might be in dire situations if the water reached them."
    },
    "193": {
        "startTime": 1017.5,
        "endTime": 1018.5,
        "transcript": "Tua-i? (Ii-i, quyana.)",
        "translation": "Is that all? (Yes, thank you.)"
    },
    "194": {
        "startTime": 1018.6,
        "endTime": 1021.0,
        "transcript": "Age, date of birth-an cauga?",
        "translation": "What's your age, date of birth?"
    },
    "195": {
        "startTime": 1022.5,
        "endTime": 1027.0,
        "transcript": "Wiinga-w' 65-aurtellrianga. Maa-i 66-aurteqatartua.",
        "translation": "I've turned 65. I'm going to be 66 this year."
    },
    "196": {
        "startTime": 1027.1,
        "endTime": 1030.0,
        "transcript": "Tan'gurraugua cali. (Qaku? Qaku?)",
        "translation": "I'm still a boy. (When? When?)"
    },
    "197": {
        "startTime": 1031.5,
        "endTime": 1032.5,
        "transcript": "March 22nd.",
        "translation": "March 22nd."
    }
};